module.exports = __webpack_public_path__ + "static/img/logo.d7af5023.png";